import type { Config } from '.';

export const devConfig: Config = {
  firebaseConfig: {
    // Dev Project
    apiKey: 'AIzaSyD67NNcu9BGo51XGqGvOyVxfcJ2JUFS1io',
    authDomain: 'matto-dev.firebaseapp.com',
    databaseURL: 'https://matto-dev.firebaseio.com',
    projectId: 'matto-dev',
    storageBucket: 'matto-dev.appspot.com',
    messagingSenderId: '1046459271258',
    appId: '1:1046459271258:web:87d12bbfc43a3f5f2cb063',
  },
  algolia: {
    appId: 'VG7BKWGDTN',
    apiKey: 'bb390271b1e9145bf9aa2f10cbeb3e3a',
  },
  typesense: {
    apiKey: '6651b17c629e571de0c617a48a0585ed',
    url: 'search-dev.matto.com',
  },
};
